// removed by extract-text-webpack-plugin
module.exports = {"Contact":"Contact__Contact___1vKjE","ContactActive":"Contact__ContactActive___h3adq","ContactHidden":"Contact__ContactHidden___2i3Dv"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ResumeBox/Contact/Contact.css
// module id = 57
// module chunks = 0